<template>
  <card-modal>
    <template v-slot:header>
      <span
        class="title-modal-card"
        v-text="$t('customerProfile.change_password')"
      />
      <v-spacer></v-spacer>
      <v-btn icon x-large @click="$emit('input', false)">
        <v-icon x-large color="primary" v-text="'mdi-close'" />
      </v-btn>
    </template>
    <template v-slot:body>
      <v-form
        ref="form"
        v-model="valid"
        :disabled="$store.getters.isLoading"
        class="pt-7"
      >
        <v-row no-gutters justify="center">
          <v-col cols="12">
            <v-text-field
              v-model="form.oldPassword"
              :append-icon="showOld ? 'mdi-eye' : 'mdi-eye-off'"
              class="inputs-default"
              :label="$t('inputs.password')"
              :type="showOld ? 'text' : 'password'"
              :rules="[$rules.required, $rules.minPassword]"
              @click:append="showOld = !showOld"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="form.newPassword"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              class="inputs-default"
              :label="$t('inputs.new_password')"
              :type="show ? 'text' : 'password'"
              :rules="[$rules.required, $rules.minPassword]"
              @click:append="show = !show"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="form.repeatNewPassword"
              class="inputs-default"
              :label="$t('inputs.repeat_new_password')"
              :type="show ? 'text' : 'password'"
              :rules="[
                $rules.required,
                $rules.repeatPasswordRules(
                  form.repeatNewPassword,
                  form.newPassword
                ),
              ]"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <v-col>
        <ButtonSuccess :valid="valid" @click="changePassword()" />
      </v-col>
    </template>
  </card-modal>
</template>

<script>
export default {
  name: "ChangePasswordForm",
  data: () => ({
    valid: false,
    showOld: false,
    show: false,
    form: new Form({
      oldPassword: "",
      newPassword: "",
      repeatNewPassword: "",
    }),
  }),
  methods: {
    changePassword: async function () {
      const self = this;
      self.$store.dispatch("loading/start");

      const { data } = await self.form.post(
        "/users/profiles/features/change/password"
      );
      Toast.fire({
        icon: "success",
        title: data.message,
      });
      self.$emit("input", false);
      self.$store.dispatch("loading/done");
    },
  },
};
</script>
